/**
 * @module xhtml-output/xhtmloutput
 */

import {Plugin} from '@oracle/ortl-core';
import {XHtmlWriter} from './xhtmlwriter.js';

/**
 * The xhtml output feature
 *
 * @extends module:core/plugin~Plugin
 */
export default class XHtmlOutput extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'XHtmlOutput';
	}

	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [];
	}

	/**
	 * @inheritDoc
	 */
	constructor(editor) {
		super(editor);

		editor.data.htmlProcessor.htmlWriter = new XHtmlWriter();
	}
}
